import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const ACTIVE_ORDERS_FOR_BELL = gql`
  query sellerActiveOrders {
    activeOrders {
      status
      checkoutType
      delivery {
        type
      }
    }
  }
`
export const ACTIVE_ORDERS_FOR_BELL_QUERY_KEY = 'useActiveOrdersForBell'

export const useActiveOrdersForBell = options =>
  useQuery({
    queryKey: [ACTIVE_ORDERS_FOR_BELL_QUERY_KEY],
    queryFn: variables => client.request(ACTIVE_ORDERS_FOR_BELL, variables),
    ...options,
  })
